export default "__VITE_ASSET__DLCnFnMz__"